import { useEffect } from 'react';

import { useFormContext } from 'react-hook-form';

import { SaveForm } from 'types/pages/audience-builder/shared/save';

export const useGiftAmountConfiguration = () => {
  const {
    control,
    formState: { errors },
    trigger,
    watch,
  } = useFormContext<SaveForm>();

  useEffect(() => {
    const subscription = watch((_, { name }) => {
      if (name === 'giftDateEnd') {
        trigger('giftDateStart');
      }

      if (name === 'giftDateStart') {
        trigger('giftDateEnd');
      }
    });

    return () => subscription.unsubscribe();
  }, [trigger, watch]);

  return { control, errors };
};
